export default __webpack_public_path__ + "static/media/mobilesnow.850cd0a8.png";